module.exports = __webpack_public_path__ + "media/images/web/home/index/music-1ad11cf206aababee90fdf397f1caa3f.jpg";